"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flightColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const selectColumn_1 = require("../../Table/columns/selectColumn");
const actionsColumn_1 = require("./actionsColumn");
const Airport_1 = require("./Cell/Airport");
const Departure_1 = require("./Cell/Departure");
const FlightDateTime_1 = require("./Cell/FlightDateTime");
const TariffsSeatsCell_1 = require("./Cell/TariffsSeatsCell");
const flightColumns = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ([
        (0, selectColumn_1.selectColumn)({
            hidden: (_a = config.select) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Departure', defaultMessage: 'Departure' })),
            accessor: 'departure',
            Cell: ({ row }) => (react_1.default.createElement(Departure_1.FlightDepartureCell, { flight: row.original, clickSequence: config.departure.clickSequence })),
            hidden: config.departure.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Number', defaultMessage: 'Number' })),
            id: 'number',
            canSort: true,
            Cell: ({ row }) => {
                return (react_1.default.createElement("div", { className: 'flight-list__table-flight-number' }, row.original.number));
            },
            hidden: (_b = config.number) === null || _b === void 0 ? void 0 : _b.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Origin', defaultMessage: 'Origin' })),
            id: 'origin',
            Cell: ({ row }) => react_1.default.createElement(Airport_1.FlightAirportCell, { airport: row.original.origin }),
            canSort: true,
            hidden: (_c = config.origin) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Destination', defaultMessage: 'Destination' })),
            id: 'destination',
            Cell: ({ row }) => react_1.default.createElement(Airport_1.FlightAirportCell, { airport: row.original.destination }),
            canSort: true,
            hidden: (_d = config.destination) === null || _d === void 0 ? void 0 : _d.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Arrival', defaultMessage: 'Arrival' })),
            accessor: 'arrival',
            Cell: ({ row }) => {
                const flight = row.original;
                return flight.arrival ? (react_1.default.createElement("div", { className: 'flight-list__table-arrival' },
                    react_1.default.createElement(FlightDateTime_1.FlightDateTime, { onlyTime: true, value: flight.arrival }))) : null;
            },
            disableSortBy: true,
            hidden: (_e = config.arrival) === null || _e === void 0 ? void 0 : _e.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ColumnTotal', defaultMessage: 'Total' })),
            id: 'totalSeats',
            Cell: ({ row }) => {
                const flight = row.original;
                return (react_1.default.createElement(TariffsSeatsCell_1.TariffsSeatsCell, { tariffGroupList: config.common.tariffGroupList, seats: flight.seatsByTariff }));
            },
            hidden: (_f = config.totalSeats) === null || _f === void 0 ? void 0 : _f.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ColumnSold', defaultMessage: 'Sold' })),
            id: 'bookedSeats',
            Cell: ({ row }) => {
                const flight = row.original;
                return (react_1.default.createElement(TariffsSeatsCell_1.TariffsSeatsCell, { isShowTotal: false, tariffGroupList: config.common.tariffGroupList, seats: flight.bookedSeatsByTariff }));
            },
            hidden: (_g = config.bookedSeats) === null || _g === void 0 ? void 0 : _g.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ColumnFree', defaultMessage: 'Free' })),
            isAvailableSeatsColumn: true,
            id: 'availableSeats',
            Cell: ({ row }) => {
                var _a;
                const flight = row.original;
                return (react_1.default.createElement(TariffsSeatsCell_1.TariffsSeatsCell, { isShowTotal: false, tariffGroupList: config.common.tariffGroupList, seats: flight.freeSeatsByTariff, allowedNegative: (_a = config.availableSeats) === null || _a === void 0 ? void 0 : _a.allowedNegative }));
            },
            hidden: (_h = config.availableSeats) === null || _h === void 0 ? void 0 : _h.hidden,
        },
        {
            Header: () => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Column:Rate', defaultMessage: 'Rate' })),
            id: 'rate',
            Cell: ({ row }) => {
                var _a;
                const flight = row.original;
                return (_a = flight.rate.name) !== null && _a !== void 0 ? _a : '';
            },
            hidden: (_j = config.rate) === null || _j === void 0 ? void 0 : _j.hidden,
        },
        (0, actionsColumn_1.flightActionsColumn)(config.actions),
    ]);
};
exports.flightColumns = flightColumns;
//# sourceMappingURL=tableColumns.js.map